require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2018-10-02-dasatinib-a-promising-anti-bcsc-agent-in-combination-with-paclitaxel-to-overcome-chemotherapy-resistance-in-tnbcs.json") })
        }
      }, "path---news-2018-10-02-dasatinib-a-promising-anti-bcsc-agent-in-combination-with-paclitaxel-to-overcome-chemotherapy-resistance-in-tnbcs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2018-10-02-dasatinib-a-promising-anti-bcsc-agent-in-combination-with-paclitaxel-to-overcome-chemotherapy-resistance-in-tnbcs!./.cache/json/news-2018-10-02-dasatinib-a-promising-anti-bcsc-agent-in-combination-with-paclitaxel-to-overcome-chemotherapy-resistance-in-tnbcs.json
// module id = 469
// module chunks = 231608221292675